import { useCallback, useMemo, useState } from "react";
import CommonOrders from "../../common/CommonOrders"
import { cancelShipment, GenerateLabel, GenerateManifest } from "../../services/shipment";
import CommonMessage from '../../common/CommonMessage';
import { CCancelButton } from "../../common/CCancelButton";
import { CGenerateLabelButton } from "../../common/CGenerateLabelButton";

const ReadyToShip = () => {
    const [message, setMessage] = useState("");
    //const [loading, setLoading] = useState(false);
    //const [loadingRow, setLoadingRow] = useState(null);
    const [loadingButton, setLoadingButton] = useState({
    wayBill: null,
    action: null,
});
   
    const handleCancelOrder = useCallback(async (rowData) => {
        setLoadingButton({
        wayBill: rowData.wayBill,
        action: "cancel",
    });


        try {
            const payload = {
                courierMasterId: rowData.courierMasterId,
                awbNo: rowData.wayBill,
            };
console.log("row",rowData);
console.log("row",rowData.courierMasterId);
            const response = await cancelShipment(payload);
            console.log("api", response);
            if (response?.statusCode === 200) {
                setMessage("Shipment canceled successfully");
                alert("Shipment canceled successfully");
            } else {
                setMessage(response?.message || "Failed to cancel shipment");
                alert(response?.message || "Failed to cancel shipment");
            }
        } catch (error) {
            console.error(error);
            setMessage(
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong"
            );
        } finally {
            setLoadingButton({
            wayBill: null,
            action: null,
        });
        }
    }, []);
    const handleGenerateLabel = useCallback(async (rowData) => {
        setLoadingButton({
        wayBill: rowData.wayBill,
        action: "label",
    });
    const courierId = rowData.courier === "Delhivery" ? 2 : 1;
        try {
            const payload = {
                courierMasterId: courierId,
                ids: [rowData.wayBill]
            };

            const response = await GenerateLabel(payload);

const blob=response;
            const url = window.URL.createObjectURL(blob);
            window.open(url, "_blank");
            
            setMessage("Label downloaded successfully.");
        } catch (error) {
            console.error(error);

            setMessage(
                error.response?.data?.message ||
                error.message ||
                "Failed to generate label."
            );
        } finally {
            setLoadingButton({
            wayBill: null,
            action: null,
        });
        }
    }, []);
const handleGenerateManifest = useCallback(async (rowData) => {
    setLoadingButton({
        wayBill: rowData.wayBill,
        action: "manifest",
    });


    try {
        const payload = {
            courierMasterId: 1,
            ids: [rowData.wayBill]
        };

        const response = await GenerateManifest(payload);
        if (response?.statusCode === 200) {
            const { manifestDownloadUrl, manifestNumber } = response.data.data;
            const link = document.createElement("a");
            link.href = manifestDownloadUrl;
            link.download = `Manifest_${manifestNumber}.pdf`;
            link.target = "_blank";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setMessage("Manifest generated successfully.");
        } else {
            setMessage(response?.data?.message || "Failed to generate manifest.");
        }
    } catch (error) {
        console.error(error);

        setMessage(
            error?.response?.data?.message ||
            error?.message ||
            "Failed to generate manifest."
        );
    } finally {
        setLoadingButton({
            wayBill: null,
            action: null,
        });
    }
}, []);

    const columnDefs = useMemo(
        () => [
            { field: "orderId", headerName: "Order ID" },
            { field: "orderType", headerName: "Order Type" },
            {
        field: "dateCreated",
        headerName: "Date Created",
      },
            { field: "wayBill", headerName: "WayBill" },
            { field: "courier", headerName: "Courier" },
            { field: "customerName", headerName: "Customer Name" },
            { field: "mobile", headerName: "Mobile" },
            { field: "email", headerName: "Email" },
            { field: "pincode", headerName: "Pincode" },
            { field: "city" },
            { field: "totalAmount", headerName: "Total Amount" },
            { field: "paymentType", headerName: "Payment Type" },
            { field: "diseaseName", headerName: "Disease Name" },
            { field: "courierStatus", headerName: "Courier Status" },
            {
                headerName: "Action",
                width: 220,      // or 250
                minWidth: 220,
                sortable: false,
                filter: false,
                cellRenderer: (params) => (
                    <div
                        style={{
                            display: "flex",
                            gap: "2px",
                            alignItems: "center"
                        }}
                    >
                        <CCancelButton
                            data={params.data}
                            onCancel={handleCancelOrder}
                            loading={
        loadingButton.wayBill === params.data.wayBill &&
        loadingButton.action === "cancel"
    }
                        />

                        <CGenerateLabelButton
                            data={params.data}
                            onGenerate={handleGenerateLabel}
                            loading={
        loadingButton.wayBill === params.data.wayBill &&
        loadingButton.action === "label"
    }
                            text="Label"
                        />
                        <CGenerateLabelButton
                            data={params.data}
                            onGenerate={handleGenerateManifest}
                            loading={
        loadingButton.wayBill === params.data.wayBill &&
        loadingButton.action === "manifest"
    }
                            text="Manifest"
                        />
                    </div>
                ),
            },

        ],
        [handleCancelOrder,
    handleGenerateLabel,
    handleGenerateManifest,
    loadingButton]
    );

    // All Grid Columns

    return (
        <>
            {/* <div class="container-fluid py-3"> */}
            <div style={{ color: "red", fontSize: "20px" }}>
                {message}
            </div>
            <CommonMessage text={message} />
            <CommonOrders statusId={2} columnDefs={columnDefs} h4={"Ready To Ship"} />
            {/* </div> */}
        </>
    );
};
export default ReadyToShip;